import React from "react";
import PropTypes from "prop-types";
import TitleBar from "../Layout/titleBar";
import { Row, Col } from "react-flexbox-grid";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import CurrencyFormat from "react-currency-format";
import TextField from "@material-ui/core/TextField";
import Checkbox from "@material-ui/core/Checkbox";
import Radio from "@material-ui/core/Radio";
import { formatMoney } from "../Common/decimalHelper";
import FormHelperText from "@material-ui/core/FormHelperText";
import CalendarioConfiguracion from "./calendarioConfiguracion";
import "./styles.css";
import { IconButton, InputAdornment, InputBase } from "@material-ui/core";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import { Alert, Collapse, Switch, FormControlLabel } from "@mui/material";

const styles = () => ({
  root: {
    zIndex: 1200,
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    boxShadow: "-5px 4px 10px #8E8E8E29",
    borderRadius: "21px",
    opacity: 1,
    padding: "0px !important",
    minWidth: "300px",
  },
  rootDialog: {
    zIndex: 1250,
  },
});

const configuracionOptions = {
  Precios: 1,
  CobroDelivery: 2,
  DeliveryBonificado: 3,
  TurneroPickupCantDias: 4,
  TurneroPickupTurnos: 5,
  DiasNoLaborablesPickup: 6,
  TurneroDeliveryCantDias: 7,
  TurneroDeliveryTurnos: 8,
  DiasNoLaborablesDelivery: 9,
  SupervisorPicking: 10,
  ModoVidriera: 11,
  FeedbackSmile: 12,
  MediosPagoOnline: 13,
};

class Configuraciones extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <div className="containerConfiguracion">
        {/* menú superior */}
        <TitleBar
          title={"Configuración"}
          handleOnBack={this.props.showSeccionPrincipal ? undefined : this.props.handleOnBack}
        />

        {/* sección precios */}
        {this.props.showSeccionPrincipal && (
          <div>
            <div>
              <div className="configTitle">Precios</div>
              <div className="itemConfigContainer">
                <div className="configText">
                  Compra mínima:{" "}
                  {this.props.montoCompraMinimo ? formatMoney(this.props.montoCompraMinimo) : "$ -"}
                </div>
                <div className="containerButtonItem">
                  <Button
                    onClick={() => {
                      this.props.handleOnClickEditar(configuracionOptions.Precios);
                    }}
                  >
                    EDITAR
                  </Button>
                </div>
              </div>
            </div>

            {/* sección precios */}
            <div className="separador"></div>

            {/* sección delivery */}
            <div>
              <div className="configTitle">Delivery</div>
              <div className="itemConfigContainer">
                <div className="configText">
                  Cobro de entrega a domicilio: {this.props.cobroDelivery ? "SI" : "NO"} (
                  {this.props.montoDelivery ? formatMoney(this.props.montoDelivery) : "$ -"})
                </div>
                <div className="containerButtonItem">
                  <Button
                    onClick={() => {
                      this.props.handleOnClickEditar(configuracionOptions.CobroDelivery);
                    }}
                  >
                    EDITAR
                  </Button>
                </div>
              </div>

              <div className="itemConfigContainer">
                <div className="configText">
                  Delivery bonificado: {this.props.deliveryBonificado ? "SI" : "NO"} (compras
                  superiores a{" "}
                  {this.props.montoDeliveryBonificado
                    ? formatMoney(this.props.montoDeliveryBonificado)
                    : "$ -"}
                  )
                </div>
                <div className="containerButtonItem">
                  <Button
                    onClick={() => {
                      this.props.handleOnClickEditar(configuracionOptions.DeliveryBonificado);
                    }}
                  >
                    EDITAR
                  </Button>
                </div>
              </div>
            </div>

            {/* sección precios */}
            <div className="separador"></div>

            {/* sección turnero pickup */}
            <div>
              <div className="configTitle">
                Turnero Pickup - Sucursal {this.props?.sucursal?.nombre}
              </div>
              <div className="itemConfigContainer">
                <div className="configText">
                  Cantidad de días habilitados para selección:{" "}
                  {this.props.cantDiasHabilitadosPickup
                    ? this.props.cantDiasHabilitadosPickup
                    : "-"}
                </div>
                <div className="containerButtonItem">
                  {this.props.cantDiasHabilitadosPickup && (
                    <Button
                      onClick={() => {
                        this.props.handleOnClickEditar(configuracionOptions.TurneroPickupCantDias);
                      }}
                    >
                      EDITAR
                    </Button>
                  )}
                </div>
              </div>
              <div className="itemConfigContainer">
                <div className="configText">Turnos</div>
                <div className="containerButtonItem">
                  {this.props.cantDiasHabilitadosPickup && (
                    <Button
                      onClick={() => {
                        this.props.handleOnClickEditar(configuracionOptions.TurneroPickupTurnos);
                      }}
                    >
                      EDITAR
                    </Button>
                  )}
                </div>
              </div>
              <div>
                <div className="itemConfigContainer">
                  <div className="configText">
                    Días no laborables:{" "}
                    {this.props.infoDiasNoLaborablesPickup
                      ? this.props.infoDiasNoLaborablesPickup
                      : ""}
                  </div>
                  <div className="containerButtonItem">
                    {this.props.cantDiasHabilitadosPickup && (
                      <Button
                        onClick={() => {
                          this.props.handleOnClickEditar(
                            configuracionOptions.DiasNoLaborablesPickup
                          );
                        }}
                      >
                        EDITAR
                      </Button>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* sección precios */}
            <div className="separador"></div>

            {/* sección turnero delivery */}
            <div>
              <div className="configTitle">
                Turnero Delivery - Sucursal {this.props?.sucursal?.nombre}
              </div>
              <div className="itemConfigContainer">
                <div className="configText">
                  Cantidad de días habilitados para selección:{" "}
                  {this.props.cantDiasHabilitadosDelivery
                    ? this.props.cantDiasHabilitadosDelivery
                    : "-"}
                </div>
                <div className="containerButtonItem">
                  {this.props.cantDiasHabilitadosDelivery && (
                    <Button
                      onClick={() => {
                        this.props.handleOnClickEditar(
                          configuracionOptions.TurneroDeliveryCantDias
                        );
                      }}
                    >
                      EDITAR
                    </Button>
                  )}
                </div>
              </div>
              <div className="itemConfigContainer">
                <div className="configText">Turnos</div>
                <div className="containerButtonItem">
                  {this.props.cantDiasHabilitadosDelivery && (
                    <Button
                      onClick={() => {
                        this.props.handleOnClickEditar(configuracionOptions.TurneroDeliveryTurnos);
                      }}
                    >
                      EDITAR
                    </Button>
                  )}
                </div>
              </div>
              <div>
                <div className="itemConfigContainer">
                  <div className="configText">
                    Días no laborables:{" "}
                    {this.props.infoDiasNoLaborablesDelivery
                      ? this.props.infoDiasNoLaborablesDelivery
                      : ""}
                  </div>
                  <div className="containerButtonItem">
                    {this.props.cantDiasHabilitadosDelivery && (
                      <Button
                        onClick={() => {
                          this.props.handleOnClickEditar(
                            configuracionOptions.DiasNoLaborablesDelivery
                          );
                        }}
                      >
                        EDITAR
                      </Button>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* sección precios */}
            <div className="separador"></div>

            {/* Seguridad */}
            {this.props.usuario !== undefined && this.props.usuario.idRol === 1 ? (
              <div>
                <div className="configTitle">Seguridad</div>
                <div className="itemConfigContainer">
                  <div className="configText">Clave supervisor picking</div>
                  <div className="containerButtonItem">
                    <Button
                      onClick={() => {
                        this.props.handleOnClickEditar(configuracionOptions.SupervisorPicking);
                      }}
                    >
                      EDITAR
                    </Button>
                  </div>
                </div>
                <div className="itemConfigContainer">
                  <div className="configText">Configuración modo vidriera</div>
                  <div className="containerButtonItem">
                    <Button
                      onClick={() => {
                        this.props.handleOnClickEditar(configuracionOptions.ModoVidriera);
                      }}
                    >
                      EDITAR
                    </Button>
                  </div>
                </div>
              </div>
            ) : null}

            {/* sección separador */}
            <div className="separador"></div>

            {/* Servicios externos */}
            {this.props.usuario !== undefined && this.props.usuario.idRol === 1 ? (
              <div>
                <div className="configTitle">Servicios externos</div>
                <div className="itemConfigContainer">
                  <div className="configText">Configuración de token Feedback Smile</div>
                  <div className="containerButtonItem">
                    <Button
                      onClick={() => {
                        this.props.handleOnClickEditar(configuracionOptions.FeedbackSmile);
                      }}
                    >
                      EDITAR
                    </Button>
                  </div>
                </div>
              </div>
            ) : null}

            {/* sección separador */}
            <div className="separador"></div>

            {/* Medios de pago online disponibles */}
            {this.props.usuario !== undefined && this.props.usuario.idRol === 1 ? (
              <div>
                <div className="configTitle">Medios de pago online</div>
                <div className="itemConfigContainer">
                  <div className="configText">Configuración de medios de pago disponibles</div>
                  <div className="containerButtonItem">
                    <Button
                      onClick={() => {
                        this.props.handleOnClickEditar(configuracionOptions.MediosPagoOnline);
                      }}
                    >
                      EDITAR
                    </Button>
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        )}

        {!this.props.showSeccionPrincipal &&
          (this.props.itemAEditar === configuracionOptions.TurneroPickupTurnos ||
            this.props.itemAEditar === configuracionOptions.TurneroDeliveryTurnos ||
            this.props.itemAEditar === configuracionOptions.DiasNoLaborablesPickup ||
            this.props.itemAEditar === configuracionOptions.DiasNoLaborablesDelivery) && (
            <CalendarioConfiguracion
              calendario={this.props.calendarioEdit}
              handleOnSaveTurno={this.props.handleOnSaveTurno}
              handleOnEliminarCalendarioHorario={this.props.handleOnEliminarCalendarioHorario}
              handleOnEliminarCalendarioNoLaborable={
                this.props.handleOnEliminarCalendarioNoLaborable
              }
              handleOnSaveCalendarioNoLaborable={this.props.handleOnSaveCalendarioNoLaborable}
              esNoLaborable={this.props.esNoLaborable}
              turneroPorLocalidad={this.props.turneroPorLocalidad}
            />
          )}

        {/* VER */}
        <Dialog
          classes={{ root: classes.rootDialog, paperScrollPaper: classes.root }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth="sm"
          open={this.props.openModal && this.props.showSeccionPrincipal}
          fullWidth={true}
        >
          <DialogContent classes={{ root: classes.root }}>
            <Row style={{ margin: "0px" }}>
              <Col xs={12} md={12} lg={12} style={{ padding: "0px" }}>
                <div className="containerModalEdicion">
                  {/* PRECIOS */}
                  {this.props.itemAEditar === configuracionOptions.Precios && (
                    <div className="containerCompraMinima" id="containerCompraMinima">
                      <div className="titleModal" id="titleModalCompraMinima">
                        Configuración precio de compra mínima
                      </div>
                      <div className="containerCantidad">
                        <div className="textLabel">Nuevo monto:</div>
                        <CurrencyFormat
                          required
                          className="currencyInput"
                          customInput={TextField}
                          error={
                            this.props.errorCompraMinima !== undefined ||
                            this.props.errorCompraMinima === ""
                              ? true
                              : false
                          }
                          helperText={
                            this.props.errorCompraMinima !== undefined ||
                            this.props.errorCompraMinima === ""
                              ? this.props.errorCompraMinima
                              : ""
                          }
                          style={{ marginTop: "15px", textAlign: "right" }}
                          decimalScale={2}
                          fixedDecimalScale={true}
                          allowNegative={false}
                          decimalSeparator=","
                          thousandSeparator="."
                          prefix={"$"}
                          value={this.props.nuevoMontoMinimo}
                          onValueChange={(e) =>
                            this.props.handleOnChangeMonto(e, "nuevoMontoMinimo")
                          }
                          id="currencyInputCompraMinima"
                        />
                      </div>
                    </div>
                  )}

                  {/* DELIVERY */}
                  {this.props.itemAEditar === configuracionOptions.CobroDelivery && (
                    <div className="containerCompraMinima">
                      <div className="titleModal">Configuración delivery</div>
                      <div className="containerContent">
                        <div className="containerCheckEntrega">
                          <div className="textLabel">Cobrar entrega </div>
                          <Checkbox
                            onChange={this.props.handleOnChange}
                            name="checkBoxCobrarEntrega"
                            checked={this.props.checkBoxCobrarEntrega}
                          />
                        </div>

                        <div className="containerCantidad">
                          <div className="textLabel">Nuevo monto:</div>
                          {
                            /*this.props.checkBoxCobrarEntrega ?*/
                            <CurrencyFormat
                              required
                              className="currencyInput"
                              customInput={TextField}
                              error={
                                this.props.errorCompraMinima !== undefined ||
                                this.props.errorCompraMinima === ""
                                  ? true
                                  : false
                              }
                              helperText={
                                this.props.errorCompraMinima !== undefined ||
                                this.props.errorCompraMinima === ""
                                  ? this.props.errorCompraMinima
                                  : ""
                              }
                              style={{ marginTop: "15px", textAlign: "right" }}
                              decimalScale={2}
                              fixedDecimalScale={true}
                              allowNegative={false}
                              decimalSeparator=","
                              thousandSeparator="."
                              prefix={"$"}
                              name="nuevoMontoDelivery"
                              value={this.props.nuevoMontoDelivery}
                              onValueChange={(e) =>
                                this.props.handleOnChangeMonto(e, "nuevoMontoDelivery")
                              }
                            />
                          }
                        </div>
                      </div>
                    </div>
                  )}

                  {/* DELIVERY BONIFICADO*/}
                  {this.props.itemAEditar === configuracionOptions.DeliveryBonificado && (
                    <div className="containerCompraMinima">
                      <div className="titleModal">Configuración delivery bonificado</div>
                      <div className="containerContent">
                        <div className="containerCheckEntrega">
                          <div className="textLabel">Bonificar delivery </div>
                          <Checkbox
                            onChange={this.props.handleOnChange}
                            name="checkBoxDeliveryBonificado"
                            checked={this.props.checkBoxDeliveryBonificado}
                          />
                        </div>

                        <div className="containerCantidad">
                          <div className="textLabel">En compras superiores a:</div>
                          {
                            /*this.props.checkBoxBonificacionDelivery ?*/
                            <CurrencyFormat
                              required
                              className="currencyInput"
                              customInput={TextField}
                              error={
                                this.props.errorMontoDeliveryBonificado !== undefined ||
                                this.props.errorMontoDeliveryBonificado === ""
                                  ? true
                                  : false
                              }
                              helperText={
                                this.props.errorMontoDeliveryBonificado !== undefined ||
                                this.props.errorMontoDeliveryBonificado === ""
                                  ? this.props.errorMontoDeliveryBonificado
                                  : ""
                              }
                              style={{ marginTop: "15px", textAlign: "right" }}
                              decimalScale={2}
                              fixedDecimalScale={true}
                              allowNegative={false}
                              decimalSeparator=","
                              thousandSeparator="."
                              prefix={"$"}
                              name="nuevoMontoDelivery"
                              value={this.props.nuevoMontoDeliveryBonificado}
                              onValueChange={(e) =>
                                this.props.handleOnChangeMonto(e, "nuevoMontoDeliveryBonificado")
                              }
                            />
                          }
                        </div>
                      </div>
                    </div>
                  )}

                  {/* DIAS HABILITADOS (PICKUP Y DELIVERY) */}
                  {(this.props.itemAEditar === configuracionOptions.TurneroDeliveryCantDias ||
                    this.props.itemAEditar === configuracionOptions.TurneroPickupCantDias) && (
                    <div className="containerCompraMinima">
                      <div className="titleModal">
                        Configuración turnero{" "}
                        {this.props.itemAEditar === configuracionOptions.TurneroPickupCantDias
                          ? "Pickup"
                          : "Delivery"}
                      </div>
                      <div className="containerContent">
                        <div className="containerCantidad">
                          <div className="textLabel">Nueva cantidad de días habilitados:</div>
                          <div>
                            <TextField
                              className="currencyInput"
                              value={
                                this.props.itemAEditar ===
                                configuracionOptions.TurneroPickupCantDias
                                  ? this.props.nuevaCantDiasHabilitadosPickup
                                  : this.props.nuevaCantDiasHabilitadosDelivery
                              }
                              name={
                                this.props.itemAEditar ===
                                configuracionOptions.TurneroPickupCantDias
                                  ? "nuevaCantDiasHabilitadosPickup"
                                  : "nuevaCantDiasHabilitadosDelivery"
                              }
                              style={{ marginTop: "15px" }}
                              onChange={this.props.handleOnChange}
                              error={
                                this.props.itemAEditar ===
                                configuracionOptions.TurneroPickupCantDias
                                  ? this.props.errores.nuevaCantDiasHabilitadosPickup
                                  : this.props.errores.nuevaCantDiasHabilitadosDelivery
                              }
                            ></TextField>

                            {(this.props.errores.nuevaCantDiasHabilitadosPickup !== undefined ||
                              this.props.errores.nuevaCantDiasHabilitadosDelivery !==
                                undefined) && (
                              <FormHelperText error style={{ marginTop: "3px" }}>
                                {this.props.itemAEditar ===
                                configuracionOptions.TurneroPickupCantDias
                                  ? this.props.errores.nuevaCantDiasHabilitadosPickup
                                  : this.props.errores.nuevaCantDiasHabilitadosDelivery}
                              </FormHelperText>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* SEGURIDAD */}
                  {this.props.itemAEditar === configuracionOptions.SupervisorPicking && (
                    <div className="containerModalAltaEdicionTurno">
                      <div className="labelTitle">Editar clave supervisor picking</div>
                      <div className="containerForm">
                        <Col xs={12} md={12} lg={12} style={{ padding: "0px" }}>
                          <div className="inputContainer">
                            <span className="label">Clave actual:</span>
                            <InputBase
                              placeholder="Ingrese clave actual"
                              className="currencyInput"
                              name="oldPassword"
                              type="password"
                              inputProps={{ style: { marginTop: "15px", textAlign: "center" } }}
                              value={this.props.oldPassword}
                              onChange={this.props.handleOnChangeInput}
                            />
                          </div>
                        </Col>
                        <Col xs={12} md={12} lg={12} style={{ padding: "0px" }}>
                          <div className="inputContainer">
                            <span className="label"> Nueva clave:</span>
                            <InputBase
                              placeholder="Ingrese nueva clave"
                              className="currencyInput"
                              name="newPassword"
                              type="password"
                              inputProps={{ style: { marginTop: "15px", textAlign: "center" } }}
                              value={this.props.newPassword}
                              onChange={this.props.handleOnChangeInput}
                            />
                          </div>
                        </Col>
                        <Col xs={12} md={12} lg={12} style={{ padding: "0px" }}>
                          <div className="inputContainer">
                            <span className="label">Repetir nueva clave:</span>
                            <InputBase
                              placeholder="Ingrese nuevamente la clave"
                              className="currencyInput"
                              name="retypeNewPassword"
                              type="password"
                              inputProps={{ style: { marginTop: "15px", textAlign: "center" } }}
                              value={this.props.retypeNewPassword}
                              onChange={this.props.handleOnChangeInput}
                              error={
                                this.props.itemAEditar === configuracionOptions.SupervisorPicking
                                  ? this.props.errores.clavesNoCoinciden
                                  : this.props.errores.clavesNoCoinciden
                              }
                            />
                          </div>
                        </Col>
                        {this.props.errores.clavesNoCoinciden && (
                          <FormHelperText error style={{ marginTop: "3px" }}>
                            {this.props.itemAEditar === configuracionOptions.SupervisorPicking
                              ? this.props.errores.clavesNoCoinciden
                              : this.props.errores.clavesNoCoinciden}
                          </FormHelperText>
                        )}
                      </div>
                    </div>
                  )}

                  {this.props.itemAEditar === configuracionOptions.ModoVidriera && (
                    <div className="containerModoVidriera">
                      <div className="titleModal">
                        Configuración del tipo de vidriera en la página online
                      </div>
                      <div className="containerCheckVidriera">
                        <div className="textLabel">Modo vidriera con precios disponibles </div>
                        <Radio
                          onChange={this.props.handleOnChange}
                          name="checkBoxVidrieraPrecio"
                          checked={this.props.checkBoxCobrarEntrega}
                        />
                        <div className="textLabel">Modo vidriera sin precios disponibles </div>
                        <Radio
                          onChange={this.props.handleOnChange}
                          name="checkBoxVidrieraNoPrecio"
                          checked={this.props.checkBoxCobrarEntrega}
                        />
                        <div className="textLabel">Modo vidriera desactivado </div>
                        <Radio
                          onChange={this.props.handleOnChange}
                          name="checkBoxVidrieraDesactivado"
                          checked={this.props.checkBoxCobrarEntrega}
                        />
                      </div>
                    </div>
                  )}

                  {this.props.itemAEditar === configuracionOptions.FeedbackSmile && (
                    <div className="containerModalAltaEdicionTurno">
                      <div className="labelTitle">Configuración de token Feedback Smile</div>
                      <div className="containerForm">
                        <Col xs={12} md={12} lg={12} style={{ padding: "0px" }}>
                          <div className="inputContainer">
                            <span className="label">Token:</span>
                            <InputBase
                              placeholder={
                                this.props.tokenFeedbackSmile ? "********" : "Ingrese token"
                              }
                              className="currencyInput"
                              name="tokenFeedbackSmile"
                              type={this.props.showPassword ? "text" : "password"}
                              inputProps={{ style: { textAlign: "center" } }}
                              value={this.props.tokenFeedbackSmile}
                              onChange={this.props.handleOnChangeTokenFeedbackSmile}
                              endAdornment={
                                <InputAdornment position="end">
                                  <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={this.props.toggleShowPassword}
                                    edge="end"
                                    style={{ color: "var(--border-config" }}
                                  >
                                    {this.props.showPassword ? <Visibility /> : <VisibilityOff />}
                                  </IconButton>
                                </InputAdornment>
                              }
                            />
                          </div>
                        </Col>
                      </div>
                    </div>
                  )}

                  {this.props.itemAEditar === configuracionOptions.MediosPagoOnline && (
                    <div className="containerModalAltaEdicionTurno">
                      <div className="labelTitle">Configuración de medios de pago online</div>
                      <div className="containerForm">
                        <div style={{ display: "flex", flexDirection: "column" }}>
                          {this.props.mediosDePagoOnlineTemporal.map((medio) => (
                            <FormControlLabel
                              key={medio.id}
                              control={
                                <Switch
                                  checked={medio.activo}
                                  onChange={(e) =>
                                    this.props.handleSwitchChangeMedioPago(
                                      medio.id,
                                      e.target.checked
                                    )
                                  }
                                  disabled={!medio.configurable}
                                />
                              }
                              label={medio.nombre}
                            />
                          ))}
                        </div>

                        <Collapse in={Boolean(this.props.showTooltipId)}>
                          <Alert
                            severity="warning"
                            onClose={() =>
                              this.props.handleSwitchChangeMedioPago(this.props.showTooltipId, true)
                            }
                            sx={{ mt: 2 }}
                          >
                            Debe haber al menos un medio activo
                          </Alert>
                        </Collapse>
                      </div>
                    </div>
                  )}

                  <div className="containerButtonsModal">
                    <Button
                      className="btnCerrarModal"
                      onClick={() => {
                        this.props.handleOnClickEditar(undefined);
                      }}
                    >
                      CERRAR
                    </Button>
                    <Button
                      className="btnGuardarModal"
                      onClick={() => this.props.handleOnClickGuardar()}
                    >
                      GUARDAR
                    </Button>
                  </div>
                </div>
              </Col>
            </Row>
          </DialogContent>
        </Dialog>
      </div>
    );
  }
}

Configuraciones.propTypes = {
  itemAEditar: PropTypes.number.isRequired,
  openModal: PropTypes.bool.isRequired,
  showSeccionPrincipal: PropTypes.bool.isRequired,
  nuevoMontoMinimo: PropTypes.number,
  nuevoMontoDelivery: PropTypes.number,
  nuevoMontoDeliveryBonificado: PropTypes.number,
  nuevaCantDiasHabilitadosPickup: PropTypes.number,
  nuevaCantDiasHabilitadosDelivery: PropTypes.number,
  cantDiasHabilitadosPickup: PropTypes.number,
  cantDiasHabilitadosDelivery: PropTypes.number,
  calendarioEdit: PropTypes.object.isRequired,
  esNoLaborable: PropTypes.bool.isRequired,
  montoCompraMinimo: PropTypes.number,
  infoDiasNoLaborablesPickup: PropTypes.string,
  infoDiasNoLaborablesDelivery: PropTypes.string,
  errorCompraMinima: PropTypes.string,
  errorMontoDeliveryBonificado: PropTypes.string,
  cobroDelivery: PropTypes.number,
  montoDelivery: PropTypes.bool.isRequired,
  deliveryBonificado: PropTypes.bool.isRequired,
  montoDeliveryBonificado: PropTypes.number,
  checkBoxCobrarEntrega: PropTypes.bool.isRequired,
  checkDeliveryBonificado: PropTypes.bool.isRequired,
  errores: PropTypes.object.isRequired,
  handleOnClickEditar: PropTypes.func.isRequired,
  handleOnChangeMonto: PropTypes.func.isRequired,
  handleOnClickGuardar: PropTypes.func.isRequired,
  handleOnChange: PropTypes.func.isRequired,
  handleOnBack: PropTypes.func.isRequired,
  handleOnEliminarCalendarioHorario: PropTypes.func.isRequired,
  handleOnEliminarCalendarioNoLaborable: PropTypes.func.isRequired,
  handleOnSaveCalendarioNoLaborable: PropTypes.func.isRequired,
  handleOnSaveTurno: PropTypes.func.isRequired,
  toggleShowPassword: PropTypes.func.isRequired,
  tokenFeedbackSmile: PropTypes.string,
};

Configuraciones.defaultProps = {};

export default withStyles(styles)(Configuraciones);
